$(document).ready(function(){



	$('.video_link').magnificPopup({
    type: 'iframe'
  });



$("#Details-menu-drawer-container").click(function(){
  setTimeout(function(){
     $("#Details-menu-drawer-container").toggleClass("cs-active")
  } );

})

$(".desktop-menu-toggle").click(function(){
$(this).toggleClass("toggle-active");
  $(".header__inline-menu").toggleClass("active")
})



  $('.women_reviews').slick({
  dots: false,
  infinite: true,
  centerPadding: '35px',
  speed: 400,
    slidesToScroll: 1,
  slidesToShow: 3,
    // cssEase: 'easeOutQuad',
     // easing: 'easeOutQuad',
    touchThreshold: 150,
  arrows:false,
  centerMode: true,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      }
    }
  ]
});

if(window.innerWidth < 991){
    $('.all_advantages_inner').slick({
  		rows: 2,
  		dots: true,
  		arrows: false,
  		infinite: true,
  		speed: 300,
  		slidesToShow: 2,
  		slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 1000,
       responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true
          }
        }
      ]
  });
  $('.custom_article_section .articles').slick({
  		dots: false,
  		arrows: false,
  		infinite: true,
  		speed: 300,
  		slidesToShow: 1,
  		slidesToScroll: 1,
        centerMode : true,
    centerPadding: '35px',
  });
}
if($(".subscription_choice_form")){
  $(".subscription_choice_form .choice_form_inner .choice_row input[type=radio]").change(function(){
      $(".plan_wrapper").removeClass("selected");
      $(".plan_desctiption").slideUp()
      $(this).next().addClass("selected");
      $(this).parent().next().slideDown();
      if($(this).val() == 0){
        $(".below_media_product_info .product__description .subscription_discription").hide();
        $(".below_media_product_info .receive_wrapper").hide();
        $(".below_media_product_info .eight_dollor_pr_month").show();
        $(".below_media_product_info .single_content").show();
        $(".below_media_product_info .product__description .subscription_eight").show();
      }else if($(this).val() == 1){
        $(".below_media_product_info .product__description .subscription_discription").hide();
        $(".below_media_product_info .receive_wrapper").hide();
        $(".below_media_product_info .seven_dollor_pr_month").show();
        $(".below_media_product_info .single_content").show();
        $(".below_media_product_info .product__description .subscription_seven").show();
      }else if($(this).val() == 2){
        $(".below_media_product_info .product__description .subscription_discription").hide();
       $(".below_media_product_info .receive_wrapper").hide();
        $(".below_media_product_info .one_time_purchase").show();
        $(".below_media_product_info .single_content").hide();
        $(".below_media_product_info .product__description .one_time_details").show();

      }


    /*
      if($(this).attr("data-sub") == "one-time"){
        var onetime_id = $(".check_options_plan").find('[data-vals="one-time"]').attr("id");
        console.log("onetime_id", "#"+onetime_id);
        $("#"+onetime_id).trigger("click");
      }else if($(this).attr("data-sub") == "subscription"){
        var subscription_id = $(".check_options_plan").find('[data-vals="subscription"]').attr("id");
        console.log("subscription_id", "#"+subscription_id);
        $("#"+subscription_id).trigger("click");
      }
    */


    if($(this).attr("data-sub") == "one-time"){

      console.log('one-time If called');
      if(document.querySelector(".custom_trigger_btn")) {
        document.querySelector(".custom_trigger_btn").style.display = "none";
      }
      if(document.querySelector(".trigger_btn")) {
        document.querySelector(".trigger_btn").style.display = "block";
      }
      if(document.querySelector(".min_qty_err")) {
        document.querySelector(".min_qty_err").style.display = "none";
      }

    }else if($(this).attr("data-sub") == "subscription"){

      const drwrInner = document.querySelector('.drawer__inner');
      if(drwrInner.classList.contains('is_min_qty_livia')){
        console.log('subscription If called');
        if(document.querySelector(".custom_trigger_btn")) {
          document.querySelector(".custom_trigger_btn").style.display = "block";
        }
        if(document.querySelector(".trigger_btn")) {
          document.querySelector(".trigger_btn").style.display = "none";
        }
      }else{
        console.log('subscription Else called');
        if(document.querySelector(".trigger_btn")) {
          document.querySelector(".custom_trigger_btn").style.display = "none";
        }
        if(document.querySelector(".trigger_btn")) {
          document.querySelector(".trigger_btn").style.display = "block";
        }
        if(document.querySelector(".min_qty_err")) {
          document.querySelector(".min_qty_err").style.display = "none";
        }
      }

    }

  });
}

// $(".colors_list input[type=radio]").click(function(){
//   console.log($(this).val())
// })



$(window).scroll(function(){
  if($("#shopify-section-header").hasClass("shopify-section-header-hidden")){
      $(".product__info-container.product__info-container--sticky").addClass("top_header");
  }else{
      $(".product__info-container.product__info-container--sticky").removeClass("top_header");
  }
});
   $(".extras_section .product-form__submit").on("click",function(){
     var HedareClass = $("#shopify-section-header");
     if(HedareClass.hasClass("shopify-section-header-hidden")){
       HedareClass.removeClass("shopify-section-header-hidden")
      }
     $(this).parents(".extras_item").find(".qty_input_wrap input[type='number']").val("0");
     var this_button = $(this);
     setTimeout(function(){
       this_button.attr("disabled","disabled");
     }, 500);
   });
  // $(".product-form__submit").click(function(){
  //       if($("#shopify-section-header").hasClass(".shopify-section-header-hidden")){
  //         console.log("has class")
  //       }
  //   });
  if(window.innerWidth < 992){
    $(".site-main-button.jsChoosePlan").on("click",function(){
        $(".product__info-wrapper.grid__item").slideDown();
    });
    $(".product-info-title .choose_title").on("click",function(){
      $(".product__info-wrapper").slideUp()
    });
    $(".product-form__submit").click(function(){
        $(".product__info-wrapper").slideUp();
        if($("#shopify-section-header").hasClass(".shopify-section-header-hidden")){
          console.log("has class")
        }
    });

    // reviews section css strarst from here
      $('.livia_products_review').slick({
        dots: false,
        infinite: true,
        centerPadding: '35px',
        speed: 300,
        slidesToShow: 2,
        arrows:false,
        centerMode: true,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
            }
          }
        ]
      });
  }

});

// var lastScrollTop = 0;
// document.addEventListener("scroll", function(){
//    var st = window.pageYOffset || document.documentElement.scrollTop;
//    if (st > lastScrollTop){
//      if(document.querySelector("cart-drawer")){
//        document.querySelector("cart-drawer").classList.remove("active");
//      }
//    } else {
//      // event
//    }
//    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
// }, false);
